
// inline decimal validator
export const inlineDecimal = (value, precision = 2) => {
    return (value > 0 && RegExp(`^[0-9]*(\\.\\d{0,${precision}})?$`).test(value)) || false;
};